<template>
    <Button text='<div class="notify-when-available-text"><i class="fa-regular fa-bell"></i> Notify when available</div>' theme='dark' :reduced_opacity='true' @click='emailWhenBackInStock'/>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import Button from '@/ecom/components/buttons/Button.vue';

export default {
    components: {Button},
    emits:['notifyWhenAvailableListener'],
    methods:{
        async emailWhenBackInStock(){
        }
    }
}
</script>

<style lang="scss">
    .notify-when-available-text{
        display: flex;
        justify-content: center;
        gap: 5px;
    }
</style>